import React, { useState, useRef, useEffect } from "react";
import "./Login.css";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import Draggable from "react-draggable";
import API_BASE_URL from "../apiConfig";


const Login = () => {
  const [mailID, setMailID] = useState(""); // user types only prefix
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [storeUserID, setStoreUserID] = useState("");
  const [storeLocation, setStoreLocation] = useState("");
  const [storeName, setStoreName] = useState("");
  const [isFieldsReadOnly, setIsFieldsReadOnly] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpInput, setOtpInput] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isValidPwd, setIsValidPwd] = useState(null);

  const passwordBtnRef = useRef(null);
  const userIDRef = useRef(null);
  const newPwdRef = useRef(null);
  const otpRef = useRef(null);
  const resetModalRef = useRef(null);

  const navigate = useNavigate();

  // useEffect(() => {
  //   userIDRef.current?.focus();
  // }, []);
  useEffect(() => {
    if (showOtpModal) {
      otpRef.current?.focus();
    }
  }, [showOtpModal]);

  useEffect(() => {
    if (!showResetModal) {
      userIDRef.current?.focus();
    }
  }, [showResetModal]);

  useEffect(() => {
    if (showResetModal) {
      newPwdRef.current.focus();
    }
  }, [showResetModal]);

  const validatePassword = (val) => {
    const ok = /^(?=.*[!@#$%^&*])(?=.*[A-Za-z0-9]).{8,}$/.test(val);
    setIsValidPwd(ok);
  };

  // ✅ normalize mailID: append suffix only once
  const normalizeMailID = (id) => {
    if (id.trim() === "") return id;
    return id.endsWith("@myprisma.in") ? id : id + "@myprisma.in";
  };
  const handleDownloadManual = () => {
    const link = document.createElement("a");
    link.href = "/user-manual.pdf";
    link.download = "REOD_User_Manual.pdf";
    link.click();
  };

  const fetchUserDetails = async () => {
    const finalMailID = normalizeMailID(mailID);
    setMailID(finalMailID); // update state once

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/login_eod_data.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mailID: finalMailID, action: "getUser" }),
        }
      );

      const data = await response.json();
      console.log("User fetch response:", data);
      console.log("mailid and showresetmodal:", (mailID && showResetModal));

      if (data.success) {
        setUserName(data.userName || "");
        setStoreUserID(data.userID || "");
        setStoreName(data.storeName || "");
        setStoreLocation(data.storeLocation || "");
        setIsFieldsReadOnly(true);
        // if (showResetModal) {
        //   newPwdRef.current?.focus();
        // } else {
        //   passwordBtnRef.current?.focus();
        // }
      } else {
        alert(data.message || "User ID not found");
        setUserName("");
        setStoreUserID("");
        setStoreName("");
        setStoreLocation("");
        setIsFieldsReadOnly(false);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Failed to connect to server");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const finalMailID = normalizeMailID(mailID);
    setMailID(finalMailID);

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/login_eod_data.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            mailID: finalMailID,
            password,
            action: "verify",
          }),
        }
      );

      const data = await response.json();
      console.log("Login API response:", data);

      if (data.success) {
        navigate("/dashboard", {
          state: {
            storeName: data.storeName,
            storeLocation: data.storeLocation,
            userName: data.userName,
            userID: data.userID,
            IsAdmin: data.isAdmin,
          },
        });
      } else {
        alert(data.message || "Login failed");
      }
    } catch (error) {
      console.error("Fetch user error:", error);
      alert("Server error while fetching user");
    }
  };

  // ✅ auto append on click outside
  useEffect(() => {
    // If reset modal is open, do nothing
    if (showResetModal) return;
    const handleClickOutside = (e) => {
      if (
        userIDRef.current &&
        !userIDRef.current.contains(e.target) &&
        mailID.trim() !== ""
      ) {
        fetchUserDetails();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [mailID, showResetModal]);

  const handleVerifyOtp = () => {
    // e.preventDefault();
    fetch(`${API_BASE_URL}/api/verify_otp.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userID: storeUserID,
        otp: otpInput
      }),
    })
      .then((res) => res.json())
      .then((resp) => {
        if (resp.success) {
          alert("OTP Verified — You can now reset password.");

          setShowOtpModal(false);   // close OTP popup
          setOtpInput("");

          // ⬅️ Re-open reset password modal
          setShowResetModal(true);

        } else {
          alert(resp.message);
        }
      });
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        {showResetModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 999,
            }}
          >
            <Draggable nodeRef={resetModalRef}>
              <div
                ref={resetModalRef}
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  width: "300px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <h3 style={{ margin: 0, textAlign: "center" }}>Reset Password</h3>

                <label>Store Mail ID</label>
                <input
                  type="text"
                  value={mailID}
                  readOnly
                  style={{ background: "#e6e6e6" }}
                />

                <label>New Password</label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => {
                    const val = e.target.value;
                    setNewPassword(val);
                    validatePassword(val);
                  }}
                  ref={newPwdRef}
                  placeholder="Min 8 chars, 1 special char (e.g. @#$%)"
                  style={{
                    border: `1px solid ${isValidPwd === null ? "#ccc" : isValidPwd ? "green" : "red"
                      }`
                  }}
                />

                {/* Validation Text */}
                <div
                  style={{
                    color: isValidPwd === null ? "#555" : isValidPwd ? "green" : "red",
                    fontSize: "13px",
                    marginTop: "4px"
                  }}
                >
                  Must contain at least 8 characters and at least 1 special character.
                </div>

                <div style={{ display: "flex" }}>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      // 🔍 Password format validation
                      if (!isValidPwd) {
                        alert("Password must be at least 8 characters and contain at least 1 special character.");
                        newPwdRef.current?.focus();
                        return;
                      }

                      // 🔐 Final step: resetForce ONLY after OTP was verified
                      fetch(`${API_BASE_URL}/api/login_eod_data.php`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                          action: "resetForce",
                          userID: storeUserID,
                          mailID: mailID,
                          newPassword,
                        }),
                      })
                        .then((res) => res.json())
                        .then((p) => {
                          if (p.success) {
                            alert("Password Updated Successfully");

                            // Close modal and clear all fields
                            setShowResetModal(false);
                            setPassword("");
                            setNewPassword("");
                            setOtpInput("");
                          } else {
                            alert("Password update failed");
                          }
                        })
                        .catch(() => {
                          alert("Server error. Try again later.");
                        });
                    }}
                    style={{ padding: "8px", fontWeight: "bold", cursor: "pointer" }}
                  >
                    Update Password
                  </button>



                  <button
                    // onClick={() => setShowResetModal(false),setPassword(" ")}
                    onClick={() => {
                      setShowResetModal(false);
                      setPassword("");
                      setNewPassword("");
                    }}

                    style={{
                      padding: "6px",
                      background: "#ccc",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Draggable>
          </div>
        )}
        {showOtpModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
          >
            <div
              style={{
                background: "white",
                padding: "20px",
                width: "350px",
                borderRadius: "10px",
                textAlign: "center",
                boxShadow: "0 0 10px rgba(0,0,0,0.3)",
              }}
            >
              <h3 style={{ marginBottom: "10px" }}>Enter OTP from HQ</h3>

              <input
                ref={otpRef}
                type="text"
                value={otpInput}
                onChange={(e) => setOtpInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleVerifyOtp();
                  }
                }}
                placeholder="Enter 6-digit OTP"
                maxLength={6}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "15px",
                  textAlign: "center",
                  fontSize: "16px"
                }}
                autoFocus
              />

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <button
                  onClick={handleVerifyOtp}
                  style={{
                    padding: "10px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    background: "#4CAF50",
                    color: "white",
                    width: "48%"
                  }}
                >
                  Verify OTP
                </button>

                <button
                  onClick={() => setShowOtpModal(false)}
                  style={{
                    padding: "10px",
                    background: "#ccc",
                    cursor: "pointer",
                    width: "48%"
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}



        <h2 style={{ color: "rgba(22, 89, 234, 1)" }}>Prisma Store Login</h2>
        <Tippy content="User Manual">
          <span
            className="user-manual-icon"
            onClick={handleDownloadManual}
            style={{
              //   // backgroundColor: "#0059dfff",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "6px",
              borderRadius: "4px",
              cursor: "pointer",

              position: "absolute",   /* within .login-form */
              bottom: "8px",          /* put at bottom */
              right: "8px"            /* align to right */
            }}
          >
            <img
              src="/manual.png"
              alt="Manual Icon"
              style={{
                width: "85px",
                height: "85px",
                objectFit: "contain",
                borderRadius: '15px',
                // borderColor: 'rgba(22, 89, 234, 1)',
                border: "3px solid rgba(22, 89, 234, 1)"  // ← add this
              }}
            />
          </span>
        </Tippy>


        {/* User ID */}
        <label>User ID</label>
        {/* <Tippy content="Enter your store ID (prefix only, without @myprisma.in)" placement="right"> */}
        <input
          style={{ fontSize: "16px" }}
          type="text"
          value={mailID}
          onChange={(e) => {
            let val = e.target.value;
            if (val.includes("@")) val = val.replace("@", ""); // block "@"
            setMailID(val);

            if (val.trim() === "") {
              setUserName("");
              setStoreName("");
              setStoreLocation("");
              setIsFieldsReadOnly(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Tab") {
              fetchUserDetails(); // appends suffix once inside
            }
          }}
          required
          ref={userIDRef}
        />
        {/* Password */}
        <label>Password</label>
        {/* <Tippy content="Enter your password" placement="right"> */}
        <input
          style={{ fontSize: "16px" }}
          ref={passwordBtnRef}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {/* <div
          style={{ marginTop: "6px", fontSize: "13px", color: "blue", cursor: "pointer" }}
          onClick={() => {
            fetch(`${API_BASE_URL}/api/login_eod_data.php`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                action: "requestOtp",
                userID: storeUserID,
                mailID,
                newPassword,
              }),
            })
              .then((res) => res.json())
              .then((response) => {
                // 🟡 If second-time reset → HQ OTP required
                if (response.requireOtp) {
                  alert("Second-time password reset: OTP required from HQ.");

                  const otp = Math.floor(100000 + Math.random() * 900000);  // 6 digit OTP
                  setGeneratedOtp(otp.toString());

                  // (Optional) console log OTP -- remove in production
                  console.log("OTP for HQ:", otp, userIDRef);

                  // Send OTP to HQ Email (via your PHP mail API)
                  fetch(`${API_BASE_URL}/api/send_otp_to_hq.php`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      otp: otp,
                      // mailID: "itretail@myprisma.in",     // HQ email
                      userID: storeUserID,
                      mailTo: mailID                // store requesting reset
                    })
                  });
                  setShowOtpModal(true);
                  return;
                }

                // if (response.success) {
                //   alert("Password Updated Successfully");
                //   setShowResetModal(false);
                //   setPassword("");
                //   setNewPassword("");
                // } else {
                //   alert(response.message || "Password update failed");
                // }
                // 🟢 First-time successful update
                if (response.success) {
                  alert("Password Updated Successfully");
                  setShowResetModal(false);
                  setPassword("");
                  setNewPassword("");
                } else {
                  alert(response.message || "Password update failed");
                }
              })
              .catch(() => {
                alert("Server error. Try again later.");
              })
            // setShowResetModal(true);
          }}
        >
          Reset Password
        </div> */}
        <div
          style={{
            marginTop: "6px",
            fontSize: "13px",
            color: "blue",
            cursor: "pointer",
          }}
          onClick={() => {

            // STEP 1 → Request OTP from backend
            fetch(`${API_BASE_URL}/api/login_eod_data.php`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                action: "requestOtp",
                userID: storeUserID,
                mailID
              }),
            })
              .then((res) => res.json())
              .then((response) => {
                if (response.success) {

                  // Generate OTP on frontend ONLY for sending to HQ email
                  const otp = Math.floor(100000 + Math.random() * 900000);
                  setGeneratedOtp(otp.toString());

                  console.log("Generated OTP:", otp);

                  // STEP 2 → Send OTP email to HQ
                  fetch(`${API_BASE_URL}/api/send_otp_to_hq.php`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      otp: otp,
                      userID: storeUserID,
                      mailTo: mailID, // HQ receiving store mail
                    }),
                  });

                  // 🔔 NEW: Show alert BEFORE opening OTP modal
                  alert(`OTP has been sent to ${mailID} by Prisma Head Quarters.`);
                  // STEP 3 → Open OTP modal
                  setShowOtpModal(true);
                } else {
                  alert(response.message || "Failed to request OTP");
                }
              })
              .catch(() => {
                alert("Server error. Try again later.");
              });
          }}
        >
          Reset Password
        </div>



        {/* User Name */}
        <label>User Name</label>
        <input
          type="text"
          value={userName}
          readOnly
          style={{
            fontSize: "16px",
            backgroundColor: "#dbd8d8ff",
            pointerEvents: "none",
          }}
        />

        {/* Store Location */}
        <label>Store Location</label>
        <input
          type="text"
          value={storeLocation}
          readOnly
          style={{
            fontSize: "16px",
            backgroundColor: "#dbd8d8ff",
            pointerEvents: "none",
          }}
        />

        {/* Store Name */}
        <label>Store Name</label>
        <input
          type="text"
          value={storeName}
          readOnly
          style={{
            fontSize: "16px",
            backgroundColor: "#dbd8d8ff",
            pointerEvents: "none",
          }}
        />

        <button type="submit" style={{ fontSize: "16px" }}>
          Login
        </button>
      </form>
    </div>
  );

};

export default Login;